module.exports = __webpack_public_path__ + "img/image_body-point_01_02.b01b062d.svg";